import { render } from "./DCardBody.vue?vue&type=template&id=6203bb1a&scoped=true"
const script = {}

import "./DCardBody.vue?vue&type=style&index=0&id=6203bb1a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6203bb1a"]])

export default __exports__